import React from 'react';

import { type BlogMeta, WhatsNewArticle } from '@af/design-system-docs-ui';
import { Box, xcss } from '@atlaskit/primitives';

import header from './_images/header.png';
import Content from './_index.mdx';

export const meta: BlogMeta = {
	title: 'Atlassian UI refresh updates',
	author: 'Written by the Design System Team',
	description: 'How to apply Atlassian’s bold new visual style with the design system.',
	image: header,
	publishDate: new Date(2025, 3, 22),
	readTime: '5 min read',
	type: 'Release roundup',
	href: '/whats-new/atlassian-ui-refresh-updates',
};

const gridOverrideStyles = xcss({
	gridColumn: '12 span',
	paddingBlockEnd: 'space.200',
});

export default () => {
	return (
		<Box xcss={gridOverrideStyles}>
			<WhatsNewArticle meta={meta} content={<Content />} />
		</Box>
	);
};
